// Sesión de la cuenta (cookie del servidor), compartida por el editor y el portal. Ver docs/AULAS.md, «Cuentas».
import { api } from './api.js';

export const ROLE_NAME = { teacher: 'Maestro', student: 'Alumno', personal: 'Personal' };

/** Si el registro de maestros está abierto (REGISTRO_MAESTROS); lo actualiza fetchUser(). */
export let teacherSignup = true;

/** «Entrar con budu» ({ url } de budu) o null si está apagado; lo actualiza fetchUser(). */
export let budu = null;

/**
 * La cuenta con sesión, o null. Lanza el error si no se pudo preguntar (sin conexión o falla del servidor),
 * para no confundir «sin conexión» con «sin sesión». La cuenta trae en `plan` su objeto Plan (docs/PLANES.md: lo que
 * puede hacer con su plan, Gratis o Maker).
 */
export async function fetchUser() {
  try {
    const r = await api.get('/api/auth/me');
    if (typeof r.teacherSignup === 'boolean') teacherSignup = r.teacherSignup;
    budu = r.budu || null;
    return r.user ? { ...r.user, plan: r.plan || null } : null;
  } catch (e) {
    if (e.status === 401 || e.status === 404) return null;
    throw e;
  }
}

/**
 * Cierra la sesión y borra lo que esta cuenta dejó en el navegador (computadoras compartidas de la escuela). Devuelve
 * adónde ir después: a budu, para salir también de allá, si se entró con budu; si no, null.
 */
export async function logout() {
  try {
    const r = await api.post('/api/auth/logout');
    return typeof r.next === 'string' && /^https:\/\//.test(r.next) ? r.next : null;
  } finally {
    clearLocalData();
  }
}

/** Dirección de «Entrar con budu»: vuelve a `back` (una ruta de este sitio). */
export function buduLoginUrl(back = here()) {
  return '/sso/entrar?volver=' + encodeURIComponent(safeReturn(back) || '/inicio');
}

/** Borradores locales y último proyecto abierto: son de la cuenta que sale. Las preferencias se quedan. */
export function clearLocalData() {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (k && (k === 'arduino3d.last' || k === 'arduino3d.draft' || k.startsWith('arduino3d.draft.'))) localStorage.removeItem(k);
    }
  } catch {
    // sin almacenamiento local
  }
}

/** Solo rutas del mismo sitio («/aulas/x»), nunca «//otro.sitio» ni URL completas. */
export function safeReturn(path) {
  return typeof path === 'string' && /^\/(?![/\\])/.test(path) ? path : null;
}

export function here() {
  return location.pathname + location.search;
}

export function loginUrl(back = here()) {
  return '/entrar?volver=' + encodeURIComponent(back);
}

export function registerUrl(back = here()) {
  return '/registro?volver=' + encodeURIComponent(back);
}
